// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"877":"4957441dc465cf0d","5834":"5ac97e7580b79fbe","8468":"5f076d57cc49affc","8527":"d32938e468070751"}[chunkId] + ".css";
};